export default "__VITE_ASSET__Cy3rSk5v__"